module.exports = __webpack_public_path__ + "img/carnet-icon.e25b454d.svg";